window.appLoaded = (async function () {
    const sentryDsn = process.env.MIX_SENTRY_DSN_PUBLIC;

    if (sentryDsn) {
        const Sentry = await import('@sentry/browser');
        Sentry.init({
            debug: false,
            dsn: process.env.MIX_SENTRY_DSN_PUBLIC,
            integrations: [
                Sentry.browserTracingIntegration(),
                Sentry.replayIntegration(),
            ],

            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            tracesSampleRate: parseFloat(process.env.MIX_SENTRY_TRACES_SAMPLE_RATE) || 0.0,

            // Capture Replay for MIX_SENTRY_REPLAYS_SESSION_SAMPLE_RATE % of all sessions,
            // plus for MIX_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE % of sessions with an error
            replaysSessionSampleRate: parseFloat(process.env.MIX_SENTRY_REPLAYS_SESSION_SAMPLE_RATE) || 0.0,
            replaysOnErrorSampleRate: parseFloat(process.env.MIX_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE) || 0.0,
        });
    }

    // Vervolgens jQuery en overige modules dynamisch inladen
    const jqueryModule = await import('jquery');
    const jquery = jqueryModule.default;

    // Stel jQuery als global variabelen in, zodat ook andere modules (die via jQuery werken) dit herkennen
    window.jQuery = jquery;
    window.$ = jquery;
    window.jquery = jquery;

    // Dynamisch inladen van overige modules
    await import(/* webpackMode: 'eager' */ '@fancyapps/fancybox');
    await import(/* webpackMode: 'eager' */ './core/plugins/jquery.menu');
    await import(/* webpackMode: 'eager' */ './core/functions');
    await import(/* webpackMode: 'eager' */ './elements/search');
    await import(/* webpackMode: 'eager' */ './elements/collapse');
    await import(/* webpackMode: 'eager' */ './elements/dropdown');

    const {slideOver} = await import(/* webpackMode: 'eager' */ './elements/slide-over');
    const {mainMenuDropdown} = await import(/* webpackMode: 'eager' */ './elements/main-menu-dropdown');


    // Pas nu de jQuery document ready-code uitvoeren
    jquery(document).ready(function () {
        jquery('a[href=\'#conditionsModal\']').fancybox();

        //-- slideOver() functionality for sliding elements when a button with data-action^='slide-' is clicked
        const slideOverObject = slideOver();
        slideOverObject.init();

        //-- Main menu dropdown functionality on desktop screen-sizes
        const mainMenuObject = mainMenuDropdown();
        mainMenuObject.init();
    });


})();
